exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar-context-avatar{display:inline-flex;vertical-align:top;justify-content:center;align-items:center;width:32px;height:32px;border:1px solid #e6e6e6}.navbar-context-avatar.is-empty{border:none}.navbar-context-avatar.is-small{width:16px;height:16px}.navbar-context-avatar img{vertical-align:top;max-width:100%;max-height:100%}.navbar-context-avatar img,.navbar-context-avatar svg{transform:none}", ""]);

// exports
